var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _AssociatedMatchWithScores = _interopRequireDefault(require("./AssociatedMatchWithScores"));

var _AssociatedMatchWithDate = _interopRequireDefault(require("./AssociatedMatchWithDate"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Match/RelatedMatch.js";

var RelatedMatch = function RelatedMatch(_ref) {
  var homeTeamName = _ref.homeTeamName,
      homeTeam = _ref.homeTeam,
      awayTeamName = _ref.awayTeamName,
      awayTeam = _ref.awayTeam,
      homeScore = _ref.homeScore,
      awayScore = _ref.awayScore,
      scheduledStartTime = _ref.scheduledStartTime,
      period = _ref.period,
      matchType = _ref.matchType,
      mb = _ref.mb,
      borderX = _ref.borderX,
      formattedDate = _ref.formattedDate,
      formattedTime = _ref.formattedTime,
      textColor = _ref.textColor,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["homeTeamName", "homeTeam", "awayTeamName", "awayTeam", "homeScore", "awayScore", "scheduledStartTime", "period", "matchType", "mb", "borderX", "formattedDate", "formattedTime", "textColor"]);
  return {
    score: _react.default.createElement(_AssociatedMatchWithScores.default, (0, _extends2.default)({
      borderX: borderX,
      mb: mb,
      textColor: textColor,
      displayText: (0, _i18n.default)(matchType === '1st Leg' ? 'home_match' : 'away_match') + ":",
      homeTeam: homeTeam,
      homeTeamName: homeTeamName,
      awayTeam: awayTeam,
      awayTeamName: awayTeamName,
      homeScore: homeScore,
      awayScore: awayScore
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 13
      }
    })),
    date: _react.default.createElement(_AssociatedMatchWithDate.default, (0, _extends2.default)({
      borderX: borderX,
      mb: mb,
      textColor: textColor,
      displayText: (0, _i18n.default)(matchType === '1st Leg' ? 'home_match' : 'away_match') + ":",
      scheduledStartTime: scheduledStartTime,
      formattedDate: formattedDate,
      formattedTime: formattedTime
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 13
      }
    }))
  }[period === 'FULL_TIME' ? 'score' : 'date'];
};

RelatedMatch.defaultProps = {
  mb: 2,
  borderX: 1
};
var _default = RelatedMatch;
exports.default = _default;